<template>
    <div
        ref="container"
        class="ff-dialog-container"
        :class="'ff-dialog-container--' + (open ? 'open' : 'closed')"
        data-click-exclude="right-drawer"
    >
        <div class="ff-dialog-box" :class="boxClass">
            <div class="ff-dialog-header" data-sentry-unmask>
                {{ header }}
                <span v-if="subHeader" class="ff-dialog-subheader">{{ subHeader }}</span>
            </div>
            <div ref="content" class="ff-dialog-content" :class="contentClass">
                <slot></slot>
            </div>
            <div class="ff-dialog-actions">
                <slot name="actions">
                    <ff-button v-if="canBeCanceled" kind="secondary" data-action="dialog-cancel" @click="cancel()">{{ cancelLabel }}</ff-button>
                    <ff-button :kind="kind" data-action="dialog-confirm" :disabled="disablePrimary" @click="confirm()">{{ confirmLabel }}</ff-button>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ff-dialog',
    props: {
        header: {
            type: String,
            default: 'Dialog Box'
        },
        subHeader: {
            type: String,
            default: ''
        },
        confirmLabel: {
            type: String,
            default: 'Confirm'
        },
        cancelLabel: {
            type: String,
            default: 'Cancel'
        },
        disablePrimary: {
            type: Boolean,
            default: false
        },
        kind: {
            type: String,
            default: 'primary'
        },
        closeOnConfirm: {
            type: Boolean,
            default: true
        },
        boxClass: {
            type: String,
            default: ''
        },
        contentClass: {
            type: String,
            default: ''
        },
        canBeCanceled: {
            type: Boolean,
            default: true
        },
        notices: {
            type: Array,
            default: () => []
        }
    },
    emits: ['cancel', 'confirm'],
    data () {
        return {
            open: false
        }
    },
    computed: {
        isOpen () {
            return this.open
        }
    },
    watch: {
        open: function () {
            this.$refs.container.scrollTop = 0
        }
    },
    methods: {
        show () {
            this.open = true
        },
        close () {
            this.open = false
        },
        cancel () {
            this.close()
            this.$emit('cancel')
        },
        confirm () {
            if (this.closeOnConfirm) {
                this.close()
            }
            this.$emit('confirm')
        }
    }
}
</script>
